import React from 'react'
import { arrayOf, number, oneOf, shape, string } from 'prop-types'

import { IndicatorIcon } from '../'

import * as Styled from './IndicatorList.styles'

import { useTextContext } from 'hocs'

const IndicatorList = ({ qsrIndicators, size }) => {
  const textContext = useTextContext()
  const { current: indicatorPrefix } = React.useRef({
    1: textContext['hospital.resultList.qsrIndicatorText.low'],
    2: textContext['hospital.resultList.qsrIndicatorText.medium'],
    3: textContext['hospital.resultList.qsrIndicatorText.high'],
  })

  return (
    <Styled.IndicatorList>
      {qsrIndicators.map((indicator, index) => (
        <div className='indicator' key={ index } data-cy={ indicator.identifier }>
          <span className='icon-wrapper'>
            <IndicatorIcon type='qsr' value={ indicator.rating } size={ size } />
          </span>
          {indicator.info ? (
            <p className={ 'indicator-info' }>{indicator.info}</p>
          ) : (
            <p className={ 'indicator-info' }>
              {' '}
              {`${ indicatorPrefix[indicator.rating] }: ${ indicator.title }`}
            </p>
          )}
        </div>
      ))}
    </Styled.IndicatorList>
  )
}

IndicatorList.propTypes = {
  qsrIndicators: arrayOf(
    shape({
      rating: oneOf([1, 2, 3]).isRequired,
      title: string.isRequired,
      info: string,
    })
  ).isRequired,
  size: number.isRequired,
}

export default IndicatorList
